import { render } from "./Miaoshijun2025.vue?vue&type=template&id=b8a2dd20&scoped=true"
import script from "./Miaoshijun2025.vue?vue&type=script&lang=js"
export * from "./Miaoshijun2025.vue?vue&type=script&lang=js"

import "./Miaoshijun2025.vue?vue&type=style&index=0&id=b8a2dd20&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a2dd20"]])

export default __exports__